var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 0C12.0459 0 12.0925 0 12.1417 0C12.2558 1.41044 11.7175 2.46432 11.0632 3.2275C10.4212 3.98542 9.5421 4.7205 8.12024 4.60896C8.0254 3.21872 8.56463 2.243 9.21803 1.48158C9.82401 0.771966 10.935 0.140517 11.9994 0Z",
    fill: "url(#paint0_linear_9340_3566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3053 14.6819C16.3053 14.696 16.3053 14.7083 16.3053 14.7215C15.9057 15.9317 15.3357 16.9689 14.6401 17.9314C14.0052 18.8052 13.2271 19.9812 11.8377 19.9812C10.6371 19.9812 9.83971 19.2092 8.60931 19.1881C7.30777 19.1671 6.59201 19.8336 5.40201 20.0014C5.26588 20.0014 5.12975 20.0014 4.99626 20.0014C4.12242 19.8749 3.4172 19.1829 2.90343 18.5593C1.38848 16.7168 0.217802 14.3368 0 11.2911C0 10.9925 0 10.6948 0 10.3962C0.0922144 8.21639 1.15136 6.44412 2.55917 5.58521C3.30215 5.12853 4.32354 4.73947 5.46085 4.91336C5.94827 4.98889 6.44622 5.15575 6.8827 5.32086C7.29635 5.47982 7.81363 5.76173 8.30368 5.7468C8.63566 5.73714 8.96587 5.56413 9.30048 5.44206C10.2806 5.08813 11.2414 4.68239 12.5078 4.87296C14.0298 5.10306 15.11 5.7793 15.7774 6.82264C14.49 7.64203 13.4721 8.87682 13.646 10.9855C13.8005 12.9009 14.9141 14.0215 16.3053 14.6819Z",
    fill: "url(#paint1_linear_9340_3566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9340_3566",
    x1: 6.97009,
    y1: 2.59096e-7,
    x2: 13.0358,
    y2: 0.504982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9340_3566",
    x1: -4.58942,
    y1: 4.82422,
    x2: 19.7609,
    y2: 7.31017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.60f8ebf7b7c49f17852a5ef4ffa46643.svg";
export { ForwardRef as ReactComponent };